import { Plus } from "lucide-react";
import { HIDDEN_INGREDIENT_CHIPS } from "./review-utils";

// Hidden-ingredient prompt (plan todo 12): "Anything hidden in this meal?"
// chips that append editable low-confidence items with typical quantity/unit
// seeds and UNDEFINED nutrition. Auto-expanded for analysis sources unless
// the logging style is "fastest" (the parent computes defaultOpen via
// hiddenIngredientsDefaultOpen).

export interface HiddenIngredientsProps {
  readonly defaultOpen: boolean;
  readonly onAdd: (chipId: string) => void;
}

export function HiddenIngredients({ defaultOpen, onAdd }: HiddenIngredientsProps) {
  return (
    <details
      open={defaultOpen}
      data-testid="hidden-ingredients"
      className="rounded-2xl border border-border bg-surface p-4 shadow-sm"
    >
      <summary className="cursor-pointer list-none select-none">
        <span className="text-sm font-semibold text-text">Anything hidden in this meal?</span>
        <span className="mt-0.5 block text-xs text-text-muted">
          Cooking fats, sauces, sugar and drinks are easy to miss — tap to add one, then adjust or
          leave its nutrition unknown.
        </span>
      </summary>
      <div className="mt-3 flex flex-wrap gap-2">
        {HIDDEN_INGREDIENT_CHIPS.map((chip) => (
          <button
            key={chip.id}
            type="button"
            data-testid={`hidden-chip-${chip.id}`}
            onClick={() => onAdd(chip.id)}
            className="inline-flex min-h-[44px] items-center gap-1 rounded-full border border-border bg-surface px-4 text-sm font-semibold text-text transition-all duration-200 ease-out active:bg-accent-light active:scale-[0.98] select-none"
          >
            <Plus size={14} strokeWidth={2} aria-hidden="true" />
            {chip.label}
          </button>
        ))}
      </div>
    </details>
  );
}
